// extracted by mini-css-extract-plugin
export default {"btn":"ButtonC_btn__C1es0"};